import { useTheme } from 'styled-components';

import { PueFault } from '@dreryk/egabinet-ezla-frontend-api';

import { createInterpolatedTranslationKey, createTranslatedText } from '@dreryk/react-common';
import { Message, MessageOptions } from '@dreryk/react-components';

import { medicalLeaveTranslationKeys } from '../../../../translations';

import { StyledMedicalLeaveErrorsStatus } from './StyledMedicalLeaveErrorsStatus';

enum MedicalLeavePueErrorsStatusType {
   ERROR = 'ERROR',
}

const useMedicalLeavePueErrorsMessageOptions = (): MessageOptions<typeof MedicalLeavePueErrorsStatusType> => {
   const theme = useTheme();
   return {
      [MedicalLeavePueErrorsStatusType.ERROR]: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
      },
   };
};

type MedicalLeavePueErrorsStatusProps = {
   readonly fault?: PueFault;
};
export const MedicalLeavePueErrorsStatus = (props: MedicalLeavePueErrorsStatusProps): JSX.Element | null => {
   const options = useMedicalLeavePueErrorsMessageOptions();
   if (!props.fault) {
      return null;
   }
   // eslint-disable-next-line init-declarations
   let translationKey: string | undefined;
   if (props.fault.errorCode && props.fault.errorMessage) {
      translationKey = medicalLeaveTranslationKeys.common.pueFaultWithCode;
   } else if (props.fault.errorCode && !props.fault.errorMessage) {
      translationKey = medicalLeaveTranslationKeys.common.pueFaultWithCodeOnly;
   }
   return (
      <StyledMedicalLeaveErrorsStatus>
         <Message
            type={MedicalLeavePueErrorsStatusType.ERROR}
            options={options}
            label={
               translationKey
                  ? createInterpolatedTranslationKey(translationKey, {
                       errorCode: props.fault.errorCode,
                       errorMessage: props.fault.errorMessage,
                    })
                  : createTranslatedText(props.fault.errorMessage)
            }
            testId='pueFault'
            displayIndicator
            fullWidth
         />
      </StyledMedicalLeaveErrorsStatus>
   );
};
